import getTemplates from './get-templates';
import getAllTemplatesCount from './get-all-templates-count';
import getSingleTemplate from './get-single-template';
import getTemplateBySlug from './get-template-by-slug';

export default {
  getTemplates,
  getAllTemplatesCount,
  getSingleTemplate,
  getTemplateBySlug,
};
